import { styled } from "goober";
import { type ReactNode, useState } from "react";
import { Icon } from "../../Icon";
import { PressButton } from "../../PressButton";
import { Text } from "../../Text";

const Header = styled(PressButton)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: transparent;
  border: 0;
  padding: 10px 8px;
  cursor: pointer;
  border-radius: 8px;
  text-align: left;
  &:hover {
    background: var(--alpha4);
  }
`;

const Chevron = styled("span")`
  display: inline-flex;
  opacity: 0.5;
  transition: transform 0.15s ease;
  &[data-open="true"] {
    transform: rotate(180deg);
  }
`;

const Body = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 8px;
`;

export function Disclosure({
  title,
  description,
  open: openProp,
  onOpenChange,
  children,
}: {
  title: string;
  description?: string;
  open?: boolean;
  onOpenChange?: (next: boolean) => void;
  children: ReactNode;
}) {
  const [internalOpen, setInternalOpen] = useState(false);
  const open = openProp ?? internalOpen;
  const toggle = () => {
    const next = !open;
    if (openProp === undefined) setInternalOpen(next);
    onOpenChange?.(next);
  };
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <Header aria-expanded={open} onPress={toggle}>
        <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Text variant="text-small-md">{title}</Text>
          {description && (
            <Text variant="text-small" color="var(--text-secondary)">
              {description}
            </Text>
          )}
        </div>
        <Chevron data-open={open}>
          <Icon name="chevron-down" size={12} />
        </Chevron>
      </Header>
      {open && <Body>{children}</Body>}
    </div>
  );
}
